import { render, staticRenderFns } from "./Projets.vue?vue&type=template&id=4db99433"
import script from "./Projets.vue?vue&type=script&lang=js"
export * from "./Projets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports